// extracted by mini-css-extract-plugin
export default {"root":"JM5pq8","placeholder":"p6N_XL"};